
export default {
  inject: ['wording'],
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    messages() {
      if (this.wording?.promo) {
        const allMessages = this.wording.promo.filter(({ disabled }) => {
          return !disabled
        })
        const actifMessages = []
        allMessages.forEach((m) => {
          if (!m.products_trigger) actifMessages.push(m)
          if (m.products_trigger) {
            const triggersIds = m.products_trigger
              .replace(/\s/g, '')
              .toUpperCase()
              .split(',')
            if (
              triggersIds.includes(
                this.product?.sku.split('-').slice(0, -1).join('-')
              )
            )
              actifMessages.push(m)
          }
        })
        return actifMessages
      }
      return null
    },
  },
}
